<script>
/**
 * <cookie-manager></cookie-manager>
 * @desc component to handle cookies for the application
 */
import cookies from '@/mixins/cookies'

export default {
  // Name
  name: 'app-cookie-manager',

  // Mixins
  mixins: [cookies],

  // Data
  data () {
    return {
      prefix: 'GA_7bk094',
      path: '/',
      expires: '12/31/9999'
    }
  },

  // Computed
  computed: {
    application () {
      const application = { ...this.$store.state.application }
      delete application.ioBB
      delete application.fpBB
      return application
    }
  },

  // Watch
  watch: {
    application: {
      // Watch the application state, set the 'input' cookie on change
      handler: function () {
        this.setInputCookie()
      },
      deep: true
    }
  },

  // Mounted
  mounted () {
    // Listen for a 'submit_application' event to set the 'applicant' cookie
    this.$bus.$on('submit_application', () => {
      this.setApplicantCookie()
    })

    // Listen to 'onbeforeunload' events to set the 'bounce' cookie
    window.onbeforeunload = () => {
      this.setBounceCookie()
    }
  },

  // Methods
  methods: {
    /**
    * Creates a comma-separated list of all steps after the 'currentStep'
    * @returns {String}
    */
    getMissedSteps () {
      const stepHandler = this.$parent.$refs.StepHandler
      if (!stepHandler) return
      const currentStep = stepHandler.currentStep
      let stepsArray = []
      for (let key of Object.keys(stepHandler.steps)) {
        stepsArray.push(key)
      }
      const currentIndex = stepsArray.indexOf(currentStep)
      return stepsArray.slice(currentIndex).join(',')
    },

    /**
    * Set the 'applicant' cookie when the user completes the Application
    * Cookie value includes a timestamp of their application
    */
    setApplicantCookie () {
      const date = new Date().toString()
      this.$_cookies_setItem(
        `${this.prefix}-applicant`,
        date,
        this.expires,
        this.path
      )
    },

    /**
    * Set the 'bounce' cookie when the user navigates away from the page
    * Cookie value includes a timestamp of the bounce, and any steps that have been missed
    */
    setBounceCookie () {
      const date = new Date().toString()
      this.$_cookies_setItem(
        `${this.prefix}-bounce`,
        `${date},${this.getMissedSteps()}`,
        this.expires,
        this.path
      )
    },

    /**
    * Set the 'input' cookie when the user updates the application
    * Cookie value includes a timestamp of the change, and all filled in Application fields
    */
    setInputCookie () {
      const cookie = JSON.stringify(this.application)
        .replace(/["{}]/g, '')
        .replace(/:/g, '=')
        .replace(/,/g, '&')
      const date = new Date().toString()
      this.$_cookies_setItem(
        `${this.prefix}-input`,
        `${date},${cookie}`,
        this.expires,
        this.path
      )
    }
  },

  // Render
  render: () => {
    return undefined
  }
}
</script>
